<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="6">
        <v-card>
          <v-card-title>Accessibility Feedback</v-card-title>

          <v-card-text>
            <p class="mb-0">
              We are committed to making our website accessible to everyone. If you encounter any
              accessibility barriers or have suggestions for improvement, please use the form below
              to let us know.
            </p>

            <div ref="feedback-form-container"></div>

            <p v-if="has_error" class="mt-4">
              Unable to load the feedback form. Please contact us directly at
              <a href="mailto:help@redchirp.com">help@redchirp.com</a> to report accessibility
              issues.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// TODO: once compliance is achieved, render a more formal accessibility statement via https://accessibleweb.com/accessibility-statement-generator/

export default {
  data() {
    return {
      has_error: false,
    };
  },

  methods: {
    load_feedback_script() {
      if (document.getElementById('aweb-feedback')) return;

      const script = document.createElement('script');
      script.id = 'aweb-feedback';
      script.type = 'text/javascript';
      script.src =
        'https://ramp.accessibleweb.com/feedback/9eCO7SVipQc94deg49Rgj07gox32TV3MJ5vjjgbfbbQ/script.js';
      script.async = true;
      script.defer = true;

      script.onerror = () => {
        this.has_error = true;
      };

      const container = this.$refs['feedback-form-container'];
      if (container) container.appendChild(script);
    },

    cleanup_feedback_script() {
      const script = document.getElementById('aweb-feedback');
      if (script) script.remove();
    },
  },

  mounted() {
    this.load_feedback_script();
  },

  beforeDestroy() {
    this.cleanup_feedback_script();
  },
};
</script>

<style lang="scss" scoped></style>
